module.exports = __webpack_public_path__ + "static/asr-cdef6023d00e9a93bb0b1eae8f355795.jpeg";